import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Form, Select, DatePicker, Spin, Table } from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo-black.svg";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { getIncomeStatement, getIncomeStatementNew } from "../../redux/actions/incomeStatement.action.js";
import "./IncomeStatementFinal.css"
import { useDownloadExcel } from "react-export-table-to-excel";

const IncomeStatementFinal = ({ token }) => {
  TabTitle("Income Statement")
  const { incomeStatement } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const history = useHistory();
  var date = moment();

  const [dateTypeId, setDateTypeId] = useState("mte");
  const [monthId, setMonthId] = useState(date.format("M"));
  const [yearId, setYearId] = useState(date.format("Y"));
  const [monthToId, setMonthToId] = useState(date.format("M"));
  const [yearToId, setYearToId] = useState(date.format("Y"));




  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);

  const { submited } = useParams();
  const [netIncome, setNetIncome] = useState();
  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Income Statement",
    sheet: "Income Statement",
  });

  useEffect(() => {
    let year = yearId;
    let month = monthId;
    let yearto = yearToId;
    let monthto = monthToId;
    let currentYearStartDate = moment().startOf("year").format("MM/DD/YYYY");
    let currentYearEndDate = moment().endOf("year").format("MM/DD/YYYY");
    let lastYearStartDate = moment()
      .startOf("year")
      .subtract(1, "year")
      .format("MM/DD/YYYY");
    let lastYearEndDate = moment()
      .endOf("year")
      .subtract(1, "year")
      .format("MM/DD/YYYY");

    if (dateTypeId === "mte") {
      currentYearStartDate = month + "/" + "01" + "/" + year;
      currentYearEndDate = monthto + "/" + moment(`${yearto} / ${monthto}`, "YYYY/MM").daysInMonth() + "/" + yearto;
    }






    const newState = {
      cy_start_date: currentYearStartDate,
      cy_end_date: currentYearEndDate,
    };
    setFormState(newState);
  }, [dateTypeId, monthId, yearId, monthToId, yearToId]);


  const onFinish = () => {
    setLoading(true);
    dispatch(getIncomeStatement(token, formState)).then((res) => {
      if (res?.type === "GET_INCOME_STATEMENT_SUCCESS") {

        setLoading(false);
      }
    });
  };



  const groupedData = incomeStatement &&
    incomeStatement?.payload?.data?.reduce((result, item) => {
      const accttype = item[0]?.accttype;
      if (!result[accttype]) {
        result[accttype] = [];
      }
      result[accttype].push(item);
      return result;
    }, {});


  const customSortOrder = ["Income", "Cost of Goods Sold", "Expense", "Other Expense", "Other Income"];

  const groupedArray = groupedData && Object.entries(groupedData)?.map(([accttype, items]) => ({
    accttype,
    items
  }));


  groupedArray && groupedArray?.sort((a, b) => {
    const indexA = customSortOrder?.indexOf(a.accttype);
    const indexB = customSortOrder?.indexOf(b.accttype);

    return indexA - indexB;
  });


  const sums = groupedArray?.map((v) => {
    return v.items.reduce((acc, item) => {
      return item[0].finalamount?.map((itemValue, index) => {
        return (acc[index] || 0) + itemValue;
      });
    }, []);
  });


  const sums12 = groupedArray?.map((v, index) => {
    return {
      sum: v.items?.reduce((acc, item) => {
        return item[0].finalamount?.map((itemValue, index) => {
          return (acc[index] || 0) + itemValue;
        });
      }, []),
      "accttype": v.accttype
    };
  });






  let incomeArrResult = [];

  const incomeArr = sums12?.filter((val) => {
    if (val.accttype === "Income" || val.accttype === "Other Income") {
      incomeArrResult?.push(val.sum);
    }
    return val;
  });


  const incomeFinalArray = incomeArrResult && incomeArrResult[0]?.map((_, index) => {
    return incomeArrResult?.reduce((acc, arr) => acc + arr[index], 0);
  });



  let expensesResult = [];
  const expenses = sums12?.filter((val) => {
    if (val.accttype !== "Income" && val?.accttype !== "Other Income") {
      expensesResult?.push(val.sum);
    }
    return val;
  });


  const expensesFinalArray = expensesResult && expensesResult[0]?.map((_, index) => {
    return expensesResult?.reduce((acc, arr) => acc + arr[index] * -1, 0);
  });



  const sumFinal = incomeFinalArray?.map((value, index) => {
    return value + expensesFinalArray[index];
  });




  const result =
    sums?.length
      ? sums.reduce((acc, curr) =>
        acc.map((value, index) => value - curr[index])
      )
      : [];

  const total = []
  for (let i = 0; i < sums?.length; i++) {
    let sum = 0;
    for (let j = 0; j < sums[i]?.length; j++) {
      sum += sums[i][j];
    }
    total?.push(sum);
  }

  const data = sumFinal && sumFinal?.reduce(function (previousValue, currentValue) {
    return (previousValue + parseFloat(currentValue));
  }, 0);


  const grossProfit =
    Array.isArray(sums?.[0]) && Array.isArray(sums?.[1])
      ? sums[0].reduce((result, currentVal, index) => {
        result.push(currentVal - (sums[1]?.[index] ?? 0));
        return result;
      }, [])
      : [];


  const totalGrossProfit = grossProfit && grossProfit.reduce(function (previousValue, currentValue) {
    return (previousValue + parseFloat(currentValue));
  }, 0);



  const handlePrint = () => {
    window.print();
  };
  function groupExpensesByParentAccount(data) {
    const groupedExpenses = {};

    data.forEach(item => {
      const parentAccountID = item.items[0][0].parent_account_no + item.items[0][0].parent_account_name;

      if (!groupedExpenses[parentAccountID]) {
        groupedExpenses[parentAccountID] = [];
      }

      groupedExpenses[parentAccountID].push(item);
    });

    return Object.entries(groupedExpenses).map(([parentAccountID, items]) => ({
      parent_account_id: parentAccountID,
      items,
    }));
  }


  const childToParent = (childData) => {
    setNetIncome(childData)
  }




  return (
    <>
      <div className="container-fluid" >
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>
                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {incomeStatement ? (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            onClick={onDownload}
                            style={{
                              borderWidth: "0px",
                              height: "14px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Income Statement
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              {
                <div className="row pb-2">
                  <div className="col">
                    <Form
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      layout="horizontal"
                      form={form}
                      name="control-hooks"
                      onFinish={onFinish}
                    >
                      <div className="main_form row">
                        <div className=" col-6">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label htmlFor="gender_id" className="labels width30">
                              Year From:
                            </label>
                            <div style={{ marginBottom: "2px" }} className=" w-100">

                              <DatePicker
                                size="small"
                                className="filter-fields full_date"
                                value={moment(yearId)}
                                defaultValue={moment(yearId)}
                                onChange={(e) =>
                                  setYearId(moment(e).format("YYYY"))
                                }
                                picker="year"
                              />
                            </div>
                          </div>
                          <div className=" d-flex flex-row align-items-baseline">
                            <label htmlFor="gender_id" className="labels width30">
                              Year To:
                            </label>
                            <div style={{ marginBottom: "2px" }} className=" w-100">

                              <DatePicker
                                size="small"
                                className="filter-fields full_date"
                                value={moment(yearToId)}

                                onChange={(e) =>
                                  setYearToId(moment(e).format("YYYY"))
                                }
                                picker="year"
                              />
                            </div>
                          </div>
                        </div>
                        <div className=" col-6">

                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width30">Month From:</label>
                            <div style={{ marginBottom: "2px" }} className=" w-100">
                              <DatePicker
                                size="small"
                                className="filter-fields full_date"
                                value={moment(monthId)}

                                onChange={(e) =>
                                  setMonthId(moment(e).format("MM"))
                                }
                                picker="month"
                                format={"MM"}
                                mode="month"
                              />
                            </div>
                          </div>
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width30">Month To:</label>
                            <div style={{ marginBottom: "2px" }} className=" w-100">
                              <DatePicker
                                size="small"
                                className="filter-fields full_date"
                                value={moment(monthToId)}

                                onChange={(e) =>
                                  setMonthToId(moment(e).format("MM"))
                                }
                                picker="month"
                                format={"MM"}
                                mode="month"
                              />
                            </div>
                          </div>
                          <div style={{ marginTop: "0px", display: "flex", justifyContent: "end" }} >
                            {/* <label className=" no_visibility">none</label> */}
                            <Button type="primary" htmlType="submit" className='submit-btn-btm m-0'

                            >
                              Search
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
      {
        <div style={{ display: "none" }}>
          <div className="report-box-main" ref={tableRef}>
            {
              groupedArray ? (
                groupedArray.length > 0 ? (
                  <>

                    {
                      groupedArray && (
                        <>
                          <table>
                            <tr>
                              <td style={{ fontSize: "20px", fontWeight: 900, textAlign: "center" }} colSpan={groupedArray[0]?.items[0][0]?.allmonths?.length + 2}>WARP WEFT</td>
                            </tr>
                            <tr>
                              <td style={{ fontSize: "20px", fontWeight: 900, textAlign: "center" }} colSpan={groupedArray[0]?.items[0][0]?.allmonths?.length + 2}>Income Statement</td>
                            </tr>
                            <tr>
                              <td style={{ fontSize: "20px", fontWeight: 900, textAlign: "center" }} colSpan={groupedArray[0]?.items[0][0]?.allmonths?.length + 2}>From {moment(monthId, 'MM').format('MMMM')} {yearId} to {moment(monthToId, 'MM').format('MMMM')} {yearToId}</td>
                            </tr>
                          </table>
                          <table className="report-table-main" style={{ fontSize: "10px" }} >
                            <tr className="report-row-head" >
                              <td className="report-column-head first-head" style={{ backgroundColor: "#d3d3d3", fontWeight: 900 }}>Financial New</td>
                              {
                                groupedArray && groupedArray[0].items?.map((v, index) => {
                                  return v[0]?.allmonths?.map((val) => {
                                    return (
                                      index == 0 ? <>
                                        <td className="report-column-head second-head text-right" style={{ backgroundColor: "#d3d3d3", fontWeight: 900, textAlign: "center" }}>{val}</td> </> : null
                                    )
                                  })
                                })
                              }
                              <td className="report-column-head second-head text-right" style={{ backgroundColor: "#d3d3d3", fontWeight: 900 }}>Total Amount</td>
                            </tr>
                            {
                              groupedArray && groupedArray.map((val, index) => {
                                return (
                                  <>
                                    <tr className="report-hd">
                                      <th className="report-hd" style={{ textAlign: "left", padding: "0 10px" }} >{val.accttype}</th>
                                    </tr>
                                    {val?.items?.map((v) => {
                                      if ((eval(v[0]?.finalamount.join('+'))) !== 0) {
                                        return (
                                          <>
                                            <tr>
                                              <td style={{ padding: "0 20px" }}>
                                                {v[0]?.account_name}
                                              </td>

                                              {
                                                v[0]?.finalamount?.map((item) => {
                                                  return (
                                                    <>
                                                      <td className="report-value text-right">
                                                        <span style={{ color: "#000000" }}>
                                                          ${numeral(item).format("0,00.00")}
                                                        </span>
                                                      </td>
                                                    </>
                                                  )
                                                })
                                              }
                                              <td className="report-value text-right">${
                                                eval(v[0]?.finalamount.join('+')).toString().includes("e") ? "0.00" : numeral(eval(v[0]?.finalamount.join('+'))).format("0,00.00")
                                              }</td>
                                            </tr>
                                          </>
                                        )
                                      } else {
                                        return null
                                      }
                                    })}
                                    <tr className="bottom-row">
                                      <td className="total-amount-left" style={{ fontWeight: 900, textAlign: "left", padding: "0 10px" }}>Total-{val?.accttype}</td>
                                      {sums[index]?.map(it => (
                                        <>
                                          <td className="total-amount" style={{ fontWeight: 900 }}>${numeral(it).format("0,00.00")}</td>
                                        </>
                                      ))}
                                      <td className="total-amount" style={{ fontWeight: 900 }}>${numeral(total[index]).format("0,00.00")}</td>
                                    </tr>
                                    {val?.accttype === "Cost of Goods Sold" && <tr className="bottom-row">
                                      <td className="total-amount-left" style={{ fontWeight: 900, padding: "0 10px" }}>{val?.accttype == "Cost of Goods Sold" ? "Gross Profit" : null}</td>
                                      {grossProfit && grossProfit.map((v) => {
                                        return <td className="total-amount" style={{ fontWeight: 900 }}>{val?.accttype == "Cost of Goods Sold" ? "$" + numeral(v).format("0,00.00") : null}</td>
                                      })}
                                      <td className="total-amount" style={{ fontWeight: 900 }}>{val?.accttype == "Cost of Goods Sold" ? "$" + numeral(totalGrossProfit).format("0,00.00") : null}</td>
                                    </tr>}
                                  </>
                                )
                              })
                            }
                            <tr style={{ fontWeight: 900, }} >
                              <td className="total-amount-left" style={{ textAlign: "left", padding: "0 10px" }}>
                                Net Profit / Loss
                              </td>
                              {sumFinal && sumFinal.map((v) => {
                                return <td className="total-amount">${numeral(v).format("0,00.00")}</td>
                              }
                              )}
                              <td className="total-amount">${numeral(data).format("0,00.00")}</td>
                            </tr>
                          </table>
                        </>
                      )
                    }
                  </>) :
                  (
                    <div className="no-Data">
                      <h1>No Data</h1>
                    </div>
                  )
              )
                : (
                  loading && (
                    <div className="loader" style={{ marginTop: "20px" }}>
                      <Spin size="medium" />
                    </div>
                  )
                )
            }
          </div>
        </div>}
      <div
      >
        {
          incomeStatement?.payload?.data ? (
            incomeStatement?.payload?.data.length > 0 ? (
              <FinancialAccordionTable
                data={incomeStatement?.payload?.data || []}
                dateFrom={formState?.cy_start_date}
                dateTo={formState?.cy_end_date}
              />
            ) : (
              <div className="no-Data">
                <h1>No Data</h1>
              </div>
            )
          ) : (
            loading && (
              <div
                className="loader"
                style={{ marginTop: "20px" }}
              >
                <Spin size="medium" />
              </div>
            )
          )
        }
      </div>
    </>
  );
};


export default IncomeStatementFinal;

const customSortOrder = [
  "Income",
  "Cost of Goods Sold",
  "Expense",
  "Other Income",
  "Other Expense",
];

const monthOrder = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

const FinancialAccordionTable = ({ data, dateFrom, dateTo }) => {
  const [openParent1, setOpenParent1] = useState(true);
  const [openParent2, setOpenParent2] = useState(true);
  const [openSections, setOpenSections] = useState({
    Income: true,
    "Cost of Goods Sold": true,
    Expense: true,
    "Other Income": true,
    "Other Expense": true,
  });

  const {
    allMonths,
    incomeCogsSections,
    expenseSections,
    otherSections,
    ordinaryIncomeExpense,
    otherIncomeExpense,
    grossProfit,
  } = useMemo(() => {
    const flatData = data?.flat() || [];

    const months = [...new Set(flatData.flatMap((i) => i.allmonths || []))];

    months.sort((a, b) => {
      const [mA, yA] = a.toLowerCase().split(" ");
      const [mB, yB] = b.toLowerCase().split(" ");

      if (yA !== yB) return Number(yA) - Number(yB);

      return monthOrder.indexOf(mA) - monthOrder.indexOf(mB);
    });

    const grouped = flatData.reduce((acc, item) => {
      const type = item.accttype || "Others";

      if (!acc[type]) acc[type] = [];

      acc[type].push(item);

      return acc;
    }, {});

    const buildSections = (types) => {
      return customSortOrder
        .filter((t) => types.includes(t))
        .map((type) => {

          const seenAccounts = new Set();

          const rows = (grouped[type] || [])
            .filter((item) => {
              const key = item.account_no; // 👈 main fix

              if (seenAccounts.has(key)) return false;

              seenAccounts.add(key);
              return true;
            })
            .map((item) => {
              const monthMap = {};

              (item.allmonths || []).forEach((m, i) => {
                monthMap[m.toLowerCase().trim()] = Number(
                  item.finalamount?.[i] || 0
                );
              });

              const values = {};

              months.forEach((m) => {
                values[m] = monthMap[m.toLowerCase().trim()] || 0;
              });

              const total = Object.values(values).reduce(
                (s, v) => s + Number(v || 0),
                0
              );

              return {
                key: item.account_id,
                financial_row: `${item.account_no} ${item.account_name}`,
                parent_account_no: item.parent_account_no,
                parent_account_name: item.parent_account_name,
                ...values,
                total,
              };
            });

          const totalRow = {
            key: `${type}-total`,
            financial_row: `Total ${type}`,
          };

          months.forEach((m) => {
            totalRow[m] = rows.reduce(
              (s, r) => s + Number(r[m] || 0),
              0
            );
          });

          totalRow.total = rows.reduce(
            (s, r) => s + Number(r.total || 0),
            0
          );

          rows.push(totalRow);

          return {
            title: type,
            rows,
            totalRow,
          };
        });
    };

    const incomeCogsSections = buildSections([
      "Income",
      "Cost of Goods Sold",
    ]);

    console.log("incomeCogsSections", incomeCogsSections)

    const expenseSections = buildSections(["Expense"]);

    const otherSections = buildSections([
      "Other Income",
      "Other Expense",
    ]);

    const incomeSection = incomeCogsSections.find(
      (x) => x.title === "Income"
    );

    const cogsSection = incomeCogsSections.find(
      (x) => x.title === "Cost of Goods Sold"
    );

    const expenseSection = expenseSections.find(
      (x) => x.title === "Expense"
    );

    // ================= GROSS PROFIT =================

    const grossProfit = { total: 0 };

    months.forEach((m) => {
      grossProfit[m] =
        Number(incomeSection?.totalRow?.[m] || 0) -
        Number(cogsSection?.totalRow?.[m] || 0);
    });

    grossProfit.total =
      Number(incomeSection?.totalRow?.total || 0) -
      Number(cogsSection?.totalRow?.total || 0);

    // ================= ORDINARY =================

    const ordinaryIncomeExpense = { total: 0 };

    months.forEach((m) => {
      ordinaryIncomeExpense[m] =
        Number(grossProfit[m] || 0) -
        Number(expenseSection?.totalRow?.[m] || 0);
    });

    ordinaryIncomeExpense.total =
      Number(grossProfit.total || 0) -
      Number(expenseSection?.totalRow?.total || 0);

    // ================= OTHER =================

    const otherIncomeSection = otherSections.find(
      (x) => x.title === "Other Income"
    );

    const otherExpenseSection = otherSections.find(
      (x) => x.title === "Other Expense"
    );

    const otherIncomeExpense = { total: 0 };

    months.forEach((m) => {
      otherIncomeExpense[m] =
        Number(otherIncomeSection?.totalRow?.[m] || 0) -
        Number(otherExpenseSection?.totalRow?.[m] || 0);
    });

    otherIncomeExpense.total =
      Number(otherIncomeSection?.totalRow?.total || 0) -
      Number(otherExpenseSection?.totalRow?.total || 0);

    return {
      allMonths: months,
      incomeCogsSections,
      expenseSections,
      otherSections,
      ordinaryIncomeExpense,
      otherIncomeExpense,
      grossProfit,
    };
  }, [data]);

  useEffect(() => {
    if (!expenseSections?.length) return;

    setOpenSections((prev) => {
      const expenseChildState = {};

      expenseSections.forEach((section) => {
        if (section.title !== "Expense") return;

        section.rows.forEach((row) => {
          if (String(row.key).includes("-total")) return;

          const parent =
            row.parent_account_no ||
            row.financial_row.split(" ")[0];

          expenseChildState[`expense-${parent}`] = true;
        });
      });

      return {
        ...prev,
        ...expenseChildState,
      };
    });
  }, [expenseSections]);

  const getExpenseChildKeys = () => {
    const keys = new Set();

    expenseSections.forEach((section) => {
      if (section.title !== "Expense") return;

      section.rows.forEach((row) => {
        if (String(row.key).includes("-total")) return;

        const parent =
          row.parent_account_no ||
          row.financial_row.split(" ")[0];

        keys.add(`expense-${parent}`);
      });
    });

    return Array.from(keys);
  };

  const toggleAll = (value) => {
    const newState = {};

    // main sections
    customSortOrder.forEach((type) => {
      newState[type] = value;
    });

    // expense child accordions
    getExpenseChildKeys().forEach((key) => {
      newState[key] = value;
    });

    setOpenSections(newState);

    setOpenParent1(value);
    setOpenParent2(value);
  };

  const gridStyle = {
    gridTemplateColumns: `550px repeat(${allMonths.length}, 1fr) 1fr`,
  };

  const renderSections = (sections) =>
    sections.map((section) => {
      // const isOpen = openSections[section.title] !== false;
      const isOpen = !!openSections[section.title];

      // ================= EXPENSE GROUPING =================

      const groupedExpense =
        section.title === "Expense"
          ? section.rows.reduce((acc, row) => {
            if (String(row.key).includes("-total")) return acc;

            const parent =
              row.parent_account_no ||
              row.financial_row.split(" ")[0];

            if (!acc[parent]) {
              acc[parent] = {
                title:
                  row.parent_account_name || parent,
                rows: [],
              };
            }

            acc[parent].rows.push(row);

            return acc;
          }, {})
          : null;

      return (
        <div key={section.title}>
          {/* ================= MAIN SECTION HEADER ================= */}

          <div
            onClick={() =>
              setOpenSections((p) => ({
                ...p,
                [section.title]: !p[section.title],
              }))
            }
            className="financial-grid financial-section-header financial-bold"
            style={gridStyle}
          >
            <div className="financial-left financial-pl-10"
            >
              <span className="financial-toggle-icon"
              >{isOpen ? "−" : "+"} </span>
              {section.title}
            </div>

            {allMonths.map((m) => (
              <div
                key={m}
                className="financial-right"
              >
                {!isOpen
                  ? numeral(section.totalRow?.[m] || 0).format(
                    "$0,0.00"
                  )
                  : ""}
              </div>
            ))}

            <div className="financial-right" >
              {!isOpen
                ? numeral(section.totalRow?.total || 0).format(
                  "$0,0.00"
                )
                : ""}
            </div>
          </div>

          {/* ================= NORMAL ROWS ================= */}

          {isOpen &&
            section.title !== "Expense" &&
            section.rows.map((row, index, arr) => {
              const isLastRow = index === arr.length - 1;

              return (
                <div
                  key={row.key}
                  className={` financial-grid ${isLastRow ? "financial-bold financial-border-top-light" : ""}`}
                  style={gridStyle}
                >
                  <div className={`financial-left ${isLastRow ? "financial-pl-50" : "financial-pl-60"}`}
                  >
                    {
                      isLastRow ? (
                        row.financial_row
                      ) : (
                        <Link
                          className="financial-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          to={{
                            pathname: `/income-detail`,
                            search: `?account_id=${row?.key}&date_from=${dateFrom}&date_to=${dateTo}`
                          }}
                        >
                          {row.financial_row}
                        </Link>
                      )
                    }
                  </div>

                  {allMonths.map((m) => (
                    <div
                      key={m}
                      className="financial-right">
                      {numeral(row[m] || 0).format("$0,0.00")}
                    </div>
                  ))}

                  <div className="financial-right">
                    {numeral(row.total || 0).format("$0,0.00")}
                  </div>
                </div>
              );
            })
          }

          {/* ================= EXPENSE CHILD ACCORDION ================= */}

          {isOpen &&
            section.title === "Expense" && (
              <>
                {Object.entries(groupedExpense).map(
                  ([parentKey, group]) => {
                    // const parentOpen =
                    //   openSections[`expense-${parentKey}`] !==
                    //   false;
                    const parentOpen =
                      !!openSections[`expense-${parentKey}`];

                    const parentTotals = {};

                    allMonths.forEach((m) => {
                      parentTotals[m] = group.rows.reduce(
                        (s, r) => s + Number(r[m] || 0),
                        0
                      );
                    });

                    parentTotals.total = group.rows.reduce(
                      (s, r) => s + Number(r.total || 0),
                      0
                    );

                    return (
                      <div key={parentKey}>
                        {/* ===== PARENT ===== */}

                        <div
                          onClick={() =>
                            setOpenSections((p) => ({
                              ...p,
                              [`expense-${parentKey}`]:
                                !p[`expense-${parentKey}`],
                            }))
                          }
                          className="financial-grid financial-expense-parent financial-bold"
                          style={gridStyle}
                        >
                          <div className="financial-left financial-pl-25" >
                            <span className="financial-toggle-icon">
                              {parentOpen ? "−" : "+"}{" "}</span>
                            {group.title}
                          </div>

                          {allMonths.map((m) => (
                            <div
                              key={m}
                              className="financial-right">
                              {!parentOpen
                                ? numeral(
                                  parentTotals[m] || 0
                                ).format("$0,0.00")
                                : ""}
                            </div>
                          ))}

                          <div className="financial-right" >
                            {!parentOpen
                              ? numeral(
                                parentTotals.total || 0
                              ).format("$0,0.00")
                              : ""}
                          </div>
                        </div>

                        {/* ===== CHILD ROWS ===== */}

                        {parentOpen && (
                          <>
                            {group.rows.map((row) => (
                              <div
                                key={row.key}
                                className="financial-grid"
                                style={gridStyle}
                              >
                                <div className="financial-left financial-pl-75" >
                                  <Link
                                    className="financial-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={{
                                      pathname: `/income-detail`,
                                      search: `?account_id=${row?.key}&date_from=${dateFrom}&date_to=${dateTo}`
                                    }}
                                  >
                                    {row.financial_row}
                                  </Link>
                                </div>

                                {allMonths.map((m) => (
                                  <div
                                    key={m}
                                    className="financial-right" >
                                    {numeral(
                                      row[m] || 0
                                    ).format("$0,0.00")}
                                  </div>
                                ))}

                                <div className="financial-right">
                                  {numeral(
                                    row.total || 0
                                  ).format("$0,0.00")}
                                </div>
                              </div>
                            ))}

                            {/* ===== CHILD TOTAL ===== */}

                            <div
                              className="financial-padding-medium financial-border-top-light financial-bold"
                              style={gridStyle}>
                              <div className="financial-left financial-pl-64">
                                Total {group.title}
                              </div>

                              {allMonths.map((m) => (
                                <div
                                  key={m}
                                  className="financial-right">
                                  {numeral(
                                    parentTotals[m] || 0
                                  ).format("$0,0.00")}
                                </div>
                              ))}

                              <div className="financial-right">
                                {numeral(
                                  parentTotals.total || 0
                                ).format("$0,0.00")}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    );
                  }
                )}

                {/* ===== MAIN EXPENSE TOTAL ===== */}

                <div
                  className="financial-grid financial-border-top financial-border-bottom-dark financial-bold"
                  style={gridStyle}>
                  <div className="financial-left financial-pl-45">
                    Total Expense
                  </div>

                  {allMonths.map((m) => (
                    <div
                      key={m}
                      className="financial-right">
                      {numeral(
                        section.totalRow?.[m] || 0
                      ).format("$0,0.00")}
                    </div>
                  ))}

                  <div className="financial-right">
                    {numeral(
                      section.totalRow?.total || 0
                    ).format("$0,0.00")}
                  </div>
                </div>
              </>
            )}
        </div>
      );
    });

  return (

    <div
      className="scrollbar-style financial-table-wrapper ">

      <div className="financial-action-buttons">
        <button onClick={() => toggleAll(true)}>
          Expand All
        </button>

        <button onClick={() => toggleAll(false)}>
          Collapse All
        </button>
      </div>
      {/* ================= HEADER ================= */}

      <div
        className="financial-grid financial-grid-header"
        style={gridStyle}>
        <div className="financial-left financial-pl-40">
          Financial Row
        </div>

        {allMonths?.map((m) => (
          <div
            key={m}
            className="financial-right">
            {m?.charAt(0).toUpperCase() + m?.slice(1)}
          </div>
        ))}

        <div className="financial-right">
          Total
        </div>
      </div>

      {/* ================= ORDINARY ================= */}

      <div
        onClick={() => setOpenParent1((p) => !p)}
        className="financial-grid financial-section-header financial-bold"
        style={gridStyle}>
        <div className="financial-left">
          <span className="financial-toggle-icon">
            {openParent1 ? "−" : "+"} </span>
          Ordinary Income/Expense
        </div>

        {allMonths.map((m) => (
          <div
            key={m}
            className="financial-right">
            {!openParent1
              ? numeral(
                ordinaryIncomeExpense[m] || 0
              ).format("$0,0.00")
              : ""}
          </div>
        ))}

        <div className="financial-right">
          {!openParent1
            ? numeral(
              ordinaryIncomeExpense.total || 0
            ).format("$0,0.00")
            : ""}
        </div>
      </div>

      {/* ================= ORDINARY BLOCK ================= */}

      {openParent1 && (
        <>
          {renderSections(incomeCogsSections)}

          {/* ================= GROSS PROFIT ================= */}

          <div
            className="financial-padding-large financial-border-top financial-bold"
            style={gridStyle}>
            <div className="financial-left financial-pl-50">
              Gross Profit (Income - Cost of Goods Sold)
            </div>

            {allMonths.map((m) => (
              <div
                key={m}
                className="financial-right">
                {numeral(
                  grossProfit[m] || 0
                ).format("$0,0.00")}
              </div>
            ))}

            <div className="financial-right">
              {numeral(
                grossProfit.total || 0
              ).format("$0,0.00")}
            </div>
          </div>

          {/* ================= EXPENSE ================= */}

          {renderSections(expenseSections)}
        </>
      )}

      {/* ================= ORDINARY TOTAL ================= */}

      {openParent1 && (
        <div
          className="financial-grid financial-border-top-dark financial-bold"
          style={gridStyle} >
          <div className="financial-left financial-pl-40" >
            Net Ordinary Income/Expense (GP - Expense)
          </div>

          {allMonths.map((m) => (
            <div
              key={m}
              className="financial-right" >
              {numeral(
                ordinaryIncomeExpense[m] || 0
              ).format("$0,0.00")}
            </div>
          ))}

          <div className="financial-right">
            {numeral(
              ordinaryIncomeExpense.total || 0
            ).format("$0,0.00")}
          </div>
        </div>
      )}

      {/* ================= OTHER ================= */}

      <div
        onClick={() => setOpenParent2((p) => !p)}
        className="financial-grid financial-section-header financial-bold"
        style={gridStyle}>
        <div className="financial-left" >
          <span className="financial-toggle-icon">
            {openParent2 ? "−" : "+"} </span>
          Other Income and Expenses
        </div>

        {allMonths.map((m) => (
          <div
            key={m}
            className="financial-right" >
            {!openParent2
              ? numeral(
                otherIncomeExpense[m] || 0
              ).format("$0,0.00")
              : ""}
          </div>
        ))}

        <div className="financial-right">
          {!openParent2
            ? numeral(
              otherIncomeExpense.total || 0
            ).format("$0,0.00")
            : ""}
        </div>
      </div>

      {/* ================= OTHER BLOCK ================= */}

      {openParent2 && renderSections(otherSections)}

      {/* ================= OTHER TOTAL ================= */}

      {openParent2 && (
        <div
          className="financial-grid financial-border-top financial-border-bottom financial-bold"
          style={gridStyle}>
          <div className="financial-left financial-pl-40">
            Net Other Income and Expenses (OI - OE)
          </div>

          {allMonths.map((m) => (
            <div
              key={m}
              className="financial-right">
              {numeral(
                otherIncomeExpense[m] || 0
              ).format("$0,0.00")}
            </div>
          ))}

          <div className="financial-right">
            {numeral(
              otherIncomeExpense.total || 0
            ).format("$0,0.00")}
          </div>
        </div>
      )}

      {/* ================= NET INCOME ================= */}

      <div
        className="financial-padding-xl financial-income-border-top financial-bold"
        style={gridStyle}>
        <div className="financial-left financial-pl-40">
          Net Income (Ordinary I/E + Other I/E)
        </div>

        {allMonths.map((m) => {
          const netIncome =
            Number(ordinaryIncomeExpense[m] || 0) +
            Number(otherIncomeExpense[m] || 0);

          return (
            <div
              key={m}
              className="financial-right">
              {numeral(netIncome).format("$0,0.00")}
            </div>
          );
        })}

        <div className="financial-right" >
          {numeral(
            Number(ordinaryIncomeExpense.total || 0) +
            Number(otherIncomeExpense.total || 0)
          ).format("$0,0.00")}
        </div>
      </div>
    </div>
  );
};


